import { DetailedHTMLProps, HTMLAttributes } from 'react'
import { cn } from '../helpers/classnames'

const SubHeading = ({
  className,
  ...props
}: DetailedHTMLProps<
  HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>) => {
  return (
    <h2
      {...props}
      className={cn(
        'text-gray-700  dark:text-gray-100 text-xl font-bold',
        className
      )}
    />
  )
}

export default SubHeading
